import React, { useCallback, useState, useEffect } from 'react';
import { Icon, Input } from '@alifd/next';
import { Drawer, Form, Table, Message } from '@b-design/fusion';
import Button, { FormSubmit } from '@/components/Button';
import PaginationComponent from '@/components/PaginationComponent';
import { getQueryStringArgs } from '@/utils/url-parse';
import DefaultIcon from '@/assets/app-logo.png';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import debounce from 'lodash/debounce';
import './index.less';

const Component = ({ children }) => {
  return (
    <div className="display-flex flex-wrap">
      {React.Children.map(children, (child, _) => {
        return (
          <div
            className="demo-block demo-block-index display-flex flex-column justify-content-flex-end align-start"
            style={{ minWidth: '180px', flex: '1' }}
          >
            {child}
          </div>
        );
      })}
    </div>
  );
};

const AddDrawer = (props) => {
  const {
    visible,
    setVisible,
    checkItem,
    getBindAppList,
    getNoBindList,
    totalCount,
    noBindList,
    paginationValue,
    setPaginationValue,
  } = props;
  const { channelCode } = getQueryStringArgs();
  const [checkCategory, setCheckCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checkCategoryIds, setCheckCategoryIds] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    const params = {
      pageNum: paginationValue.pageNum,
      pageSize: paginationValue.pageSize,
      channelCode,
      categoryId: checkItem,
      keyword: searchValue,
    };
    getNoBindList(params);
  }, [paginationValue.pageNum, paginationValue.pageSize, searchValue]);

  useEffect(() => {
    if (checkCategoryIds.length === 0) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [checkCategoryIds]);

  const onClose = () => {
    setVisible(false);
    setCheckCategoryIds([]);
  };

  const onChange = function (selectedRowKeys, records) {
    setCheckCategory(records);
    setCheckCategoryIds(selectedRowKeys);
  };

  const rowSelection = {
    onChange: onChange,
    selectedRowKeys: checkCategoryIds,
  };

  /**
   * 翻页查询处理
   * @param current 当前页码
   * @param pageSize 每页数据量
   */
  const pageChangeHandler = (current: number, pageSize: number) => {
    setPaginationValue({
      pageNum: current,
      pageSize,
    });
  };

  const renderCheckNum = useCallback(() => {
    return (
      <div className="chooseNum">
        {$i18n.get({
          id: 'aopf.pages.miniAppStore.operate.create.selected',
          dm: '已选',
        })}
        <div style={{ margin: '0 5px' }}>
          <span>{checkCategoryIds.length}</span>/{noBindList.length}
        </div>
        {$i18n.get({
          id: 'aopf.pages.miniAppStore.operate.create.strip',
          dm: '条',
        })}
      </div>
    );
  }, [checkCategoryIds, noBindList]);

  // 关键字搜索
  const keywordSearch = (value) => {
    setSearchValue(value);
    setPaginationValue({
      pageNum: 1,
      pageSize: 10,
    });
    setCheckCategoryIds([]);
  };

  const renderAppName = (v, i, record) => {
    return (
      <div className="noBind-item">
        {record.iconPublicUrl ? <img src={record.iconPublicUrl} /> : <img src={DefaultIcon} />}
        <div>{record.name}</div>
      </div>
    );
  };

  const renderVersion = (v, i, record) => {
    return record.publishStatus === 'ONLINE' && record.onlineVersion ? record.onlineVersion : '-';
  };

  const submitForm = async () => {
    setLoading(true);
    if (checkCategory?.length > 0) {
      try {
        const res = await Requests.post('/rest/intercnn/channel/category/miniapp/bind', {
          channelCode,
          categoryId: checkItem,
          miniappCodes: checkCategoryIds,
        });
        if (res) {
          Message.success({
            title: $i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.add.successfully',
              dm: '添加成功',
            }),
          });
          getBindAppList();
          setVisible(false);
        }
      } finally {
        setLoading(false);
        setCheckCategoryIds([]);
      }
    } else {
      setVisible(false);
      setLoading(false);
    }
  };

  return (
    <Component>
      <Drawer
        title={$i18n.get({
          id: 'aopf.pages.miniAppStore.operate.setting.createMiniapp',
          dm: '选择小程序',
        })}
        placement="right"
        onClose={onClose}
        visible={visible}
        className="drawerContent"
        width={550}
      >
        <Form>
          <Input
            className="searchInput"
            innerAfter={<Icon type="search" size={12} style={{ margin: 8, color: '#B4BACC' }} />}
            placeholder={$i18n.get({
              id: 'aopf.pages.miniAppStore.operate.create.newName',
              dm: '请输入名称',
            })}
            onChange={debounce(keywordSearch, 500)}
          />

          <Table
            dataSource={noBindList}
            rowSelection={rowSelection}
            fixedHeader
            maxBodyHeight={500}
          // primaryKey='id'
          >
            <Table.Column
              title={$i18n.get({
                id: 'aopf.component.addDrawer.ChineseMiniapp',
                dm: 'Miniapp',
              })}
              cell={renderAppName}
              key="appName"
            />
            <Table.Column
              title={$i18n.get({
                id: 'aopf.pages.miniAppStore.setting.drawer.title.online.version',
                dm: '在线版本',
              })}
              dataIndex="onlineVersion"
              key="onlineVersion"
              cell={renderVersion}
            />
          </Table>
          <div className="table-footer">
            {renderCheckNum()}
            <PaginationComponent
              total={totalCount}
              current={paginationValue.pageNum}
              pageSize={paginationValue.pageSize}
              onPageChange={pageChangeHandler}
            />
          </div>
          <Form.Item name="agree" className="submitBtn">
            <div>
              <FormSubmit
                type="primary"
                disabled={loading}
                onClick={submitForm}
                validate
                style={{
                  height: 40,
                  fontWeight: 500,
                  fontSize: 16,
                  color: '#fff',
                  letterSpacing: '0.15px',
                  boxSizeing: 'border-box',
                }}
              >
                {$i18n.get({ id: 'aopf.pages.miniapp.detail.btn.ok', dm: '确认' })}
              </FormSubmit>
              <Button
                type="secondary"
                style={{
                  height: 40,
                  fontWeight: 500,
                  fontSize: 16,
                  letterSpacing: '0.15px',
                  marginLeft: 16,
                  boxSizeing: 'border-box',
                }}
                onClick={() => {
                  setVisible(false);
                }}
              >
                {$i18n.get({ id: 'aopf.pages.miniapp.detail.btn.cancel', dm: '取消' })}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Drawer>
    </Component>
  );
};

export default AddDrawer;
